const CDN_BASE_URL = 'https://sports-cdn.rmdevops.com/';
const DEV_CDN_BASE_URL = 'https://sports-cdn.dev.sports.rmdevops.com/';
const LEGACY_BASE_URLS: [string, string][] = [
    ['https://gumgum-sports-cdn.s3.amazonaws.com/', CDN_BASE_URL],
    ['https://gumgum-sports-cdn.s3.us-east-1.amazonaws.com/', CDN_BASE_URL],
    ['https://s3.amazonaws.com/gumgum-sports-cdn/', CDN_BASE_URL],
    ['https://gumgum-sports-cdn-dev.s3.amazonaws.com/', DEV_CDN_BASE_URL],
    [
        'https://gumgum-sports-cdn-dev.s3.us-east-1.amazonaws.com/',
        DEV_CDN_BASE_URL,
    ],
    ['https://s3.amazonaws.com/gumgum-sports-cdn-dev/', DEV_CDN_BASE_URL],
];

export const toSportsCdnUrl = (url: string): string => {
    const match = LEGACY_BASE_URLS.find(([legacyBaseUrl]) =>
        url.startsWith(legacyBaseUrl),
    );
    return match ? match[1] + url.slice(match[0].length) : url;
};
